import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class ProviderClinicDataService {

  constructor(private httpClient: ApiHttpClient) {
  }

  public deleteAsync(id: number | string, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ProviderClinics/Delete', id, timeout);
  }
}
